import { getLanguageDisplayName } from '@/shared/lib';

import { normalizeContentLanguage } from '@/entities/transcriptor';

// A tie goes to the language that sorts first, so the result does not depend
// on the order the templates arrive in.
export const getMostCommonLanguage = (languages: string[]) => {
  const counts = languages.reduce<Record<string, number>>(
    (result, language) => {
      const key = language.toLowerCase();
      return key ? { ...result, [key]: (result[key] ?? 0) + 1 } : result;
    },
    {},
  );
  return Object.keys(counts).sort(
    (first, second) =>
      counts[second] - counts[first] || first.localeCompare(second),
  )[0];
};

export const getRecordingLanguageCandidates = ({
  stored,
  organization,
  templateLanguages,
  locale,
}: {
  stored: string | undefined;
  organization: string | undefined;
  templateLanguages: string[];
  locale: string;
}) => [
  stored,
  organization ? normalizeContentLanguage(organization) : undefined,
  getMostCommonLanguage(templateLanguages),
  normalizeContentLanguage(locale),
];

// Candidates come in priority order; the first one with document sets wins,
// and without any match the first candidate is kept so the empty state names
// it.
export const pickRecordingLanguage = ({
  options,
  candidates,
}: {
  options: string[];
  candidates: (string | undefined)[];
}) => {
  const normalized = candidates.flatMap((candidate) =>
    candidate ? [candidate.toLowerCase()] : [],
  );
  return (
    normalized.find((candidate) => options.includes(candidate)) ??
    normalized[0] ??
    options[0] ??
    ''
  );
};

export const getLanguageLabel = (language: string, locale: string) => {
  const label = getLanguageDisplayName(language, locale);
  return `${label.charAt(0).toLocaleUpperCase(locale)}${label.slice(1)}`;
};
